import Vue from 'vue'

const state = {
  serviceType: 'service_call_requests',
  sortBy: 'created_at',
  sortDesc: true,
  filters: {
    sap_series: null,
    system_type: null,
    call_type: null
  }
}

const mutations = {
  setServiceType (state, newType) {
    Vue.set(state, 'serviceType', newType)
  },
  setSortBy (state, newSortBy) {
    Vue.set(state, 'sortBy', newSortBy)
  },
  setSortDesc (state, newSortDesc) {
    Vue.set(state, 'sortDesc', newSortDesc)
  },
  // filters
  setFilter (state, { key, value }) {
    Vue.set(state.filters, key, value)
  },
  removeFilter (state, key) {
    Vue.set(state.filters, key, null)
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}

